import {
  isAnyOf,
  socketConnected,
  startListening,
} from '@bonanza-social/toolkit/state';
import { getCashBalance } from '@bonanza-social/wallet/state';
import { Notification, RewardType } from '@bonanza-social/rewards/state';
import { purchaseShopItem, purchaseShopSlot } from '@bonanza-social/shop/state';
import { prizeWallCashRewardWon } from '@bonanza-social/prize-wall/state';

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      (notification: Notification) => {
        if (
          notification.rewards.some(
            (reward) =>
              reward.rewardType === RewardType.Cash ||
              reward.rewardType === RewardType.Bonus,
          )
        ) {
          dispatch(getCashBalance());
        }
      },
    );
  },
});

startListening({
  matcher: isAnyOf(
    purchaseShopItem.fulfilled,
    purchaseShopSlot.fulfilled,
    prizeWallCashRewardWon,
  ),
  effect: (_, { dispatch }) => {
    dispatch(getCashBalance());
  },
});
